/* ============ CISQO Sérénité — theme.js ============ */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const CFG = window.CISQO || {};

  function money(cents) {
    const v = (cents / 100).toFixed(2).replace('.', ',');
    return v + ' €';
  }
  window.cisqoMoney = money;

  /* ---------- En-tête : ombre au défilement ---------- */
  const header = $('[data-header]');
  const onScroll = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);
    const btt = $('[data-back-to-top]');
    if (btt) btt.classList.toggle('is-visible', window.scrollY > 500);
    const bubble = $('[data-cart-bubble]');
    if (bubble) bubble.classList.toggle('is-visible', window.scrollY > 500 && window.innerWidth < 900);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  $$('[data-back-to-top]').forEach(b => b.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' })));

  /* ---------- Menu mobile ---------- */
  const mobileNav = $('[data-mobile-nav]');
  $$('[data-mobile-toggle]').forEach(b => b.addEventListener('click', () => mobileNav && mobileNav.classList.add('is-open')));
  if (mobileNav) {
    $$('[data-close]', mobileNav).forEach(b => b.addEventListener('click', () => mobileNav.classList.remove('is-open')));
  }

  /* ---------- Recherche prédictive ---------- */
  const searchPanel = $('[data-search-panel]');
  $$('[data-search-toggle]').forEach(b => b.addEventListener('click', () => {
    if (!searchPanel) return;
    searchPanel.classList.toggle('is-open');
    if (searchPanel.classList.contains('is-open')) { const i = $('input[name="q"]', searchPanel); if (i) i.focus(); }
  }));
  const searchInput = searchPanel && $('input[name="q"]', searchPanel);
  const searchResults = searchPanel && $('[data-search-results]', searchPanel);
  let searchTimer;
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(() => {
        fetch(`${CFG.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search`)
          .then(r => r.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const res = doc.querySelector('[data-predictive-inner]');
            searchResults.innerHTML = res ? res.innerHTML : '<p>Aucun résultat.</p>';
          })
          .catch(() => { searchResults.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------- Panier coulissant ---------- */
  const drawer = $('[data-cart-drawer]');
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } }
  window.cisqoOpenDrawer = openDrawer;
  $$('[data-cart-toggle],[data-cart-bubble]').forEach(b => b.addEventListener('click', e => {
    if (CFG.cartType === 'drawer') { e.preventDefault(); refreshCart().then(openDrawer); }
  }));
  if (drawer) $$('[data-close]', drawer).forEach(b => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); $$('.modal.is-open').forEach(m => m.classList.remove('is-open')); } });

  function refreshCart() {
    return fetch(`${CFG.routes.cart}?section_id=cart-drawer`)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-inner]');
        const target = drawer && drawer.querySelector('[data-cart-inner]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        return fetch('/cart.js').then(r => r.json()).then(cart => {
          $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none'; });
          return cart;
        });
      });
  }
  window.cisqoRefreshCart = refreshCart;

  /* ---------- Ajout au panier (formulaires) ---------- */
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.noAjax) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '…'; }
    fetch(CFG.routes.cartAdd, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(() => refreshCart())
      .then(() => {
        if (btn) { btn.innerHTML = CFG.strings.addedToCart; setTimeout(() => { btn.innerHTML = original; btn.disabled = false; }, 1200); }
        if (CFG.cartType === 'drawer') openDrawer(); else window.location = CFG.routes.cart;
      })
      .catch(() => { if (btn) { btn.innerHTML = original; btn.disabled = false; } });
  });

  /* ---------- Modification des quantités du panier ---------- */
  document.addEventListener('click', function (e) {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    const line = b.dataset.line, qty = b.dataset.lineChange;
    fetch(CFG.routes.cartChange, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(() => refreshCart());
  });

  /* ---------- Sélecteur de pack (bundles) ---------- */
  $$('[data-bundles]').forEach(group => {
    const qtyInput = document.querySelector(group.dataset.target || '[data-qty-input]');
    group.addEventListener('click', e => {
      const opt = e.target.closest('[data-bundle]');
      if (!opt) return;
      $$('[data-bundle]', group).forEach(o => o.classList.remove('is-active'));
      opt.classList.add('is-active');
      const q = opt.dataset.bundle;
      if (qtyInput) { qtyInput.value = q; qtyInput.dispatchEvent(new Event('change', { bubbles: true })); }
      const label = document.querySelector('[data-bundle-total]');
      if (label && opt.dataset.total) label.textContent = opt.dataset.total;
    });
  });

  /* ---------- Page produit : variantes ---------- */
  $$('[data-variant-selects]').forEach(root => {
    const data = JSON.parse($('[data-variant-json]', root).textContent);
    const selects = $$('select[data-option-index]', root);
    const hidden = $$('input[data-option-value]', root);
    const idInput = $('[data-variant-id]', root);
    const priceEl = document.querySelector('[data-price-target]');
    const btn = document.querySelector('[data-atc-button]');
    const optionCount = selects.length + hidden.length;
    function chosenValues() {
      const out = [];
      selects.forEach(s => { out[Number(s.dataset.optionIndex)] = s.value; });
      hidden.forEach(h => { out[Number(h.dataset.optionIndex)] = h.value; });
      return out;
    }
    $$('[data-option-pill]', root).forEach(p => p.addEventListener('click', () => {
      const i = p.dataset.optionIndex;
      $$(`[data-option-pill][data-option-index="${i}"]`, root).forEach(x => x.classList.remove('is-active'));
      p.classList.add('is-active');
      const h = root.querySelector(`input[data-option-value][data-option-index="${i}"]`);
      if (h) h.value = p.dataset.value;
      update();
    }));
    function update() {
      const chosen = chosenValues();
      const variant = data.find(v => v.options.every((o, i) => o === chosen[i]));
      if (!variant) { if (btn) { btn.disabled = true; btn.textContent = CFG.strings.unavailable; } return; }
      idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.compare_at_price > variant.price
        ? `<span>${money(variant.price)}</span><span class="price__old">${money(variant.compare_at_price)}</span>`
        : `<span>${money(variant.price)}</span>`;
      if (btn) {
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? btn.dataset.label : CFG.strings.soldOut;
      }
      if (variant.featured_media) {
        const img = document.querySelector('[data-main-image]');
        if (img && variant.featured_media.preview_image) img.src = variant.featured_media.preview_image.src;
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      document.dispatchEvent(new CustomEvent('cisqo:variant', { detail: variant }));
    }
    selects.forEach(s => s.addEventListener('change', update));
  });

  /* ---------- Cartes produit : variantes + quantite ---------- */
  $$('[data-card-form]').forEach(form => {
    const uid = form.dataset.cardForm;
    const json = document.querySelector(`[data-card-variants="${uid}"]`);
    if (!json) return;
    let data;
    try { data = JSON.parse(json.textContent); } catch (e) { return; }
    const selects = $$(`[data-card-option="${uid}"]`, form);
    const idInput = form.querySelector(`[data-card-variant-id="${uid}"]`);
    const priceEl = document.querySelector(`[data-card-price="${uid}"]`);
    const btn = form.querySelector(`[data-card-atc="${uid}"]`);
    if (!selects.length) return;
    const label = btn ? btn.textContent : 'Acheter';
    function sync() {
      const chosen = [];
      selects.forEach(s => { chosen[Number(s.dataset.optionIndex)] = s.value; });
      const variant = data.find(x => x.options.every((o, i) => o === chosen[i]));
      if (!variant) {
        if (btn) { btn.disabled = true; btn.textContent = CFG.strings.unavailable; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = variant.compare_at_price > variant.price
          ? `<span>${money(variant.price)}</span><span class="price__old">${money(variant.compare_at_price)}</span>`
          : `<span>${money(variant.price)}</span>`;
      }
      if (btn) {
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? label : CFG.strings.soldOut;
      }
    }
    selects.forEach(s => s.addEventListener('change', sync));
    sync();
  });

  /* ---------- Galerie produit ---------- */
  $$('[data-gallery]').forEach(g => {
    const main = $('[data-main-image]', g);
    $$('[data-thumb]', g).forEach(t => t.addEventListener('click', () => {
      $$('[data-thumb]', g).forEach(x => x.classList.remove('is-active'));
      t.classList.add('is-active');
      if (main) main.src = t.dataset.full;
    }));
    const zoomWrap = $('.zoomable', g);
    if (zoomWrap && main) {
      zoomWrap.addEventListener('mousemove', e => {
        const r = zoomWrap.getBoundingClientRect();
        main.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
      });
      zoomWrap.addEventListener('mouseenter', () => { main.style.transform = 'scale(1.9)'; main.style.transition = 'transform .2s'; });
      zoomWrap.addEventListener('mouseleave', () => { main.style.transform = ''; });
    }
  });

  /* ---------- Accordéons & onglets ---------- */
  document.addEventListener('click', e => {
    const acc = e.target.closest('.accordion__btn');
    if (acc) acc.parentElement.classList.toggle('is-open');
    const tab = e.target.closest('[data-tab]');
    if (tab) {
      const wrap = tab.closest('[data-tabs-root]');
      $$('[data-tab]', wrap).forEach(t => t.classList.remove('is-active'));
      $$('.tab-panel', wrap).forEach(p => p.classList.remove('is-active'));
      tab.classList.add('is-active');
      const panel = wrap.querySelector(`#${tab.dataset.tab}`);
      if (panel) panel.classList.add('is-active');
    }
    const hs = e.target.closest('.hotspot');
    if (hs) { const open = hs.classList.contains('is-open'); $$('.hotspot').forEach(h => h.classList.remove('is-open')); if (!open) hs.classList.add('is-open'); }
  });

  /* ---------- Barre d'achat flottante ---------- */
  const sticky = $('[data-sticky-atc]');
  if (sticky) {
    const anchor = $('[data-atc-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(anchor);
    }
  }

  /* ---------- Comparateur avant / après ---------- */
  $$('[data-compare]').forEach(c => {
    const after = $('.compare__after', c), handle = $('.compare__handle', c);
    const move = x => {
      const r = c.getBoundingClientRect();
      let p = ((x - r.left) / r.width) * 100;
      p = Math.max(0, Math.min(100, p));
      after.style.width = p + '%';
      handle.style.left = p + '%';
    };
    let down = false;
    c.addEventListener('pointerdown', e => { down = true; move(e.clientX); });
    window.addEventListener('pointermove', e => { if (down) move(e.clientX); });
    window.addEventListener('pointerup', () => { down = false; });
  });

  /* ---------- Aperçu rapide ---------- */
  const qv = $('[data-quick-view]');
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-quick-view-open]');
    if (!b || !qv) return;
    e.preventDefault();
    const body = $('[data-quick-view-body]', qv);
    body.innerHTML = '<p>Chargement…</p>';
    qv.classList.add('is-open');
    fetch(`${b.dataset.url}?section_id=quick-view-content`)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('[data-qv-inner]');
        body.innerHTML = inner ? inner.innerHTML : '<p>Produit indisponible.</p>';
      });
  });
  if (qv) $$('[data-close],.modal__overlay', qv).forEach(x => x.addEventListener('click', () => qv.classList.remove('is-open')));

  /* ---------- Fenêtre promotionnelle ---------- */
  const popup = $('[data-popup]');
  if (popup && !localStorage.getItem('cisqo_popup_seen')) {
    setTimeout(() => popup.classList.add('is-open'), (Number(popup.dataset.delay) || 8) * 1000);
    $$('[data-close],.modal__overlay', popup).forEach(x => x.addEventListener('click', () => {
      popup.classList.remove('is-open');
      localStorage.setItem('cisqo_popup_seen', '1');
    }));
  }

  /* ---------- Vérificateur d'âge ---------- */
  const gate = $('[data-age-gate]');
  if (gate && !localStorage.getItem('cisqo_age_ok')) {
    gate.classList.add('is-open');
    const yes = $('[data-age-yes]', gate);
    if (yes) yes.addEventListener('click', () => { localStorage.setItem('cisqo_age_ok', '1'); gate.classList.remove('is-open'); });
    const no = $('[data-age-no]', gate);
    if (no) no.addEventListener('click', () => { window.location = 'https://www.google.fr'; });
  }

  /* ---------- Défilement infini ---------- */
  const more = $('[data-load-more]');
  if (more) {
    const load = () => {
      const url = more.dataset.next;
      if (!url) return;
      more.textContent = 'Chargement…';
      fetch(url).then(r => r.text()).then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelector('[data-product-grid]');
        const next = doc.querySelector('[data-load-more]');
        if (items) $('[data-product-grid]').insertAdjacentHTML('beforeend', items.innerHTML);
        if (next && next.dataset.next) { more.dataset.next = next.dataset.next; more.textContent = 'Voir plus de produits'; }
        else more.remove();
      });
    };
    more.addEventListener('click', load);
    if (more.dataset.auto === 'true' && 'IntersectionObserver' in window) {
      new IntersectionObserver(en => { if (en[0].isIntersecting) load(); }, { rootMargin: '400px' }).observe(more);
    }
  }

  /* ---------- Produits vus récemment ---------- */
  const pid = document.body.dataset.productId;
  if (pid) {
    let seen = JSON.parse(localStorage.getItem('cisqo_seen') || '[]');
    seen = [pid].concat(seen.filter(x => x !== pid)).slice(0, 12);
    localStorage.setItem('cisqo_seen', JSON.stringify(seen));
  }
  const rv = $('[data-recently-viewed]');
  if (rv) {
    const seen = JSON.parse(localStorage.getItem('cisqo_seen') || '[]').filter(x => x !== pid).slice(0, 4);
    if (seen.length) {
      const q = seen.map(id => `id:${id}`).join(' OR ');
      fetch(`/search?section_id=recently-viewed&type=product&q=${encodeURIComponent(q)}`)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('[data-rv-inner]');
          if (inner && inner.children.length) { rv.innerHTML = inner.innerHTML; rv.closest('section').style.display = ''; }
        });
    }
  }

  /* ---------- Barre d'achat flottante : bouton Acheter ---------- */
  document.addEventListener('click', function (e) {
    const b = e.target.closest('[data-sticky-buy]');
    if (!b) return;
    const form = document.getElementById(b.dataset.form);
    if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
  });

  /* ---------- Emballage cadeau ---------- */
  document.addEventListener('change', function (e) {
    const gw = e.target.closest('[data-gift-wrap]');
    if (!gw) return;
    if (gw.checked) {
      const fd = new FormData();
      fd.append('id', gw.dataset.variant);
      fd.append('quantity', '1');
      fetch(CFG.routes.cartAdd, { method: 'POST', body: fd, headers: { Accept: 'application/json' } }).then(() => refreshCart());
    } else if (gw.dataset.line) {
      fetch(CFG.routes.cartChange, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(gw.dataset.line), quantity: 0 })
      }).then(() => refreshCart());
    }
  });

  /* ---------- Animations à l'apparition ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(el => io.observe(el));
  } else {
    $$('.reveal').forEach(el => el.classList.add('is-in'));
  }
})();
